import axios from "../../lib/axiosInstance";

export function getCustomerUsers({
  page = 1,
  limit = 20,
  search = "",
  customerId,
  sortBy,
  sortOrder,
  fullName,
  email,
  country,
  status,
  includeOwner,
} = {}) {
  return axios
    .get("customerUsers/members", {
      params: {
        page,
        limit,
        search,
        ...(customerId && { customerId }),
        ...(sortBy && { sortBy, sortOrder }),
        ...(fullName && { fullName }),
        ...(email && { email }),
        ...(country && { country }),
        ...(status && { status }),
        ...(includeOwner && { includeOwner: true }),
      },
    })
    .then((res) => res.data);
}

export function createCustomerPortalUser(payload) {
  return axios.post("customerUsers/createUser", payload).then((res) => res.data);
}

export function removeCustomerPortalUser(id, reason) {
  return axios.delete(`customerUsers/${id}`, { data: { reason } }).then((res) => res.data);
}

// One or many: the listing always sends an array, whether it is a row action or a
// multi-select.
export function setCustomerPortalUsersActive(userIds, active) {
  return axios.patch("customerUsers/status", { userIds, active }).then((res) => res.data);
}

export function removeCustomerPortalUsers(userIds, reason) {
  return axios.post("customerUsers/remove", { userIds, reason }).then((res) => res.data);
}
